import { atom } from "jotai";

import { EventMetaInfo } from "../types";

export * from "./groupEvent";

export const EventDetailMetaInfoAtom = atom<EventMetaInfo | null>(null);

export const EventDetailAddPeopleSearchAtom = atom<string>("");

export const EventDetailAddPeopleSearchOpenAtom = atom<boolean>(false);
